var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"name-value-item clear"},[_c('span',{staticClass:"name",class:[_vm.nameClass || ''],style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"text",style:(_vm.contentStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }